import React from 'react';

import { useSelector } from 'react-redux';

import Modal from '@components/styled-UI/Modal';

import PreLoader from '@images/svg-icons/preLoader.svg';

import { RootState } from 'src/store/reducers';

import { getLabelFallback } from '@utils/utils';

interface Props {
    isOpenDeleteModal?: boolean;
    isSubmitting?: boolean;
    onModalSubmit?: () => void;
    onCloseModal?: () => void;
}

const EyeExamCancelModal = ({
    isOpenDeleteModal = false,
    isSubmitting = false,
    onModalSubmit,
    onCloseModal,
}: Props): JSX.Element => {
    const isMobile = useSelector((state: RootState) => state.common.isMobile);

    return (
        <Modal
            isOpen={isOpenDeleteModal}
            close={onCloseModal}
            isCentered
            customStyle={isMobile ? 'eye-exams-modal-sm' : 'eye-exams-modal'}
        >
            <div className="eye-exams-delete-modal">
                <div role="region" aria-label="Eye exams cancel exam modal title" className="title">
                    {getLabelFallback('MYAPPOINTMENT_EYE_EXAMS_CANCEL_MODAL_MESSAGE')}
                </div>
                <div className="buttons-container">
                    <button
                        data-element-id="OEEOverlay_Remove"
                        data-description="Confirm"
                        role="region"
                        aria-label="Eye exams cancel exam modal, cancel button"
                        className={`primary-button button-size-medium ${
                            isSubmitting ? 'loading' : ''
                        }`}
                        onClick={onModalSubmit}
                    >
                        {getLabelFallback('MYAPPOINTMENT_EYE_EXAMS_CANCEL_MODAL_CONFIRM_CTA_LABEL')}
                        {isSubmitting && <PreLoader />}
                    </button>
                    <button
                        data-element-id="OEEOverlay_Remove"
                        data-description="Back"
                        role="region"
                        aria-label="Eye exams cancel exam modal, cancel button"
                        className="primary-button-negative button-size-medium"
                        onClick={onCloseModal}
                    >
                        {getLabelFallback('MYAPPOINTMENT_EYE_EXAMS_CANCEL_MODAL_CANCEL_CTA_LABEL')}
                    </button>
                </div>
            </div>
        </Modal>
    );
};
export default EyeExamCancelModal;
